import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Params, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AppState } from '../store/app.reducer';
import { LOCALSTORAGE_RETURN_URL } from '../conf/user';

@Injectable({ providedIn: 'root' })
class AuthorizationService {
  constructor(private store: Store<AppState>, private router: Router,) {}

  // eslint-disable-next-line
  canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot
  ): boolean |
      UrlTree |
      Promise<boolean | UrlTree> |
      Observable<boolean | UrlTree> {
      return this.store.select('auth', 'tokenData').pipe(
          map(tokenData => {
              const isAuth = !!tokenData?.access_token;
              if (!isAuth) {
                  const path = router.url.split('?')[0];
                  const queryParams = route.queryParams;
                  const returnUrl = {
                      path,
                      queryParams
                  };
                  localStorage.setItem(LOCALSTORAGE_RETURN_URL, JSON.stringify(returnUrl));
                  this.router.navigate(['/login']);
                  return false;
              }
              return true;
          })
      );
  }
}

export const canActivateGuard: CanActivateFn = (route, state) => {
  return inject(AuthorizationService).canActivate(route, state);
};
